import { amber, green, grey, indigo, lightGreen, pink, purple, red, yellow } from '@material-ui/core/colors';
import createPalette from '@material-ui/core/styles/createPalette';
/**
 * Custom palette configuration for AgentNet. To be extended by each brand where needed.
 *
 * @returns {Palette}
 */
export const palette = createPalette({
    action: {
        active: '#0075c3',
        hover: '#2e7ea80a',
        hoverOpacity: 0.04,
        selected: '#2e7ea814',
        selectedOpacity: 0.08,
        disabled: '#2e7ea860',
        disabledBackground: '#2e7ea81e',
        disabledOpacity: 0.38,
        focus: '#2e7ea81e',
        focusOpacity: 0.12,
    },
    background: {
        default: '#ffffff',
        paper: '#ffffff',
    },
    common: {
        black: '#000000',
        white: '#ffffff',
    },
    divider: '#cfd8dc',
    primary: {
        main: '#2e7ea8',
        dark: '#1f5470',
        light: '#dceff9',
        contrastText: '#ffffff',
    },
    secondary: {
        main: '#65788f',
        dark: '#3d4d5f',
        light: '#d5dce2',
        contrastText: '#ffffff',
    },
    error: {
        main: '#ac1209',
        dark: '#9a0c05',
        light: '#be382f',
        contrastText: '#ffffff',
    },
    info: {
        main: '#039be5',
        dark: '#0277bd',
        light: '#29b6f6',
        contrastText: '#ffffff',
    },
    success: {
        main: '#43a047',
        dark: '#2e7d32',
        light: '#66bb6a',
        contrastText: '#ffffff',
    },
    text: {
        primary: '#212121',
        secondary: '#616161',
        disabled: '#9e9e9e',
        hint: '#677784',
    },
    warning: {
        main: '#fb8c00',
        dark: '#ef6c00',
        light: '#ffa726',
        contrastText: '#ffffff',
    },
    brand: {
        charcoal: '#2f2f2f',
        feather: '#f4f4f4',
        feather25: '#fafafa',
        feather50: '#f9f9f9',
        foundation: '#141d3a',
        gold: '#ebbd5f',
        legacy: '#013a6f',
        lilRed: '#e62e1f',
        sky: '#dceff9',
        sky25: '#f6fbfd',
        sky50: '#edf7fc',
        vivid: '#4eade1',
        vividDark: '#1688c5',
        welcome: '#0075c3',
        finance: {
            main: '#af9e69',
            light: '#dbd4bd',
            dark: '#ffffff',
            contrastText: '#ffffff',
        },
        knowledge: {
            main: '#ebbd5f',
            light: '#fbf0db',
            dark: '#da9a1b',
            contrastText: '#ffffff',
        },
        marketing: {
            main: '#e17e26',
            light: '#f8dfc9',
            dark: '#b46118',
            contrastText: '#ffffff',
        },
    },
    document: {
        default: '#d0e3f5',
        docFile: '#0075c3',
        email: '#009688',
        excel: '#33691e',
        folder: '#1c9489',
        html: '#2196f3',
        image: '#0288d1',
        pdf: '#b71c1c',
        powerpoint: '#d84315',
        template: '#00497a',
        video: '#827717',
        word: '#01579b',
    },
    status: {
        canceled: '#ac1209',
        closed: '#013a6f',
        closedBackground: '#edf7fc',
        draft: '#bdbdbd',
        error: '#ac1209',
        info: '#039be5',
        open: '#43a047',
        pending: '#fb8c00',
        void: '#4f4178',
        voidBackground: '#dcd9e4',
    },
    actionSecondary: {
        active: '#65788F',
        disabled: '#65788f61',
        disabledBackground: '#65788f1f',
        focus: '#65788f1f',
        hover: '#65788f0a',
        hoverOpacity: 0.04,
        selected: '#65788f14',
    },
    statesPrimary: {
        disabledBackground: '#2e7ea80f',
        disabledBorder: '#2e7ea84d',
        focus: '#2e7ea81f',
        focusVisible: '#2e7ea84d',
        hover: '#2e7ea80a',
        hoverBorder: '#2e7ea8b3',
        outlinedBorder: '#2e7ea880',
        selected: '#2e7ea814',
    },
    statesSecondary: {
        disabledBackground: '#65788f0f',
        disabledBorder: '#65788f4d',
        focus: '#65788f1f',
        focusVisible: '#65788f4d',
        hover: '#65788f0a',
        hoverBorder: '#65788fb3',
        outlinedBorder: '#65788f80',
        selected: '#65788f14',
    },
    accordion: {
        document: '#00497a',
        property: '#004d40',
        buyer: '#4f4178',
        seller: '#bf360c',
        lender: '#901949',
        editBackground: '#f8dfc9',
        activeBackground: '#F6FBFD', //brand/sky25
    },
    highlightIcon: {
        main: '#013A6F',
        highlight: '#96BED3',
    },
    agGrid: {
        disabledBackground: '#FAFAFA',
        overrideBackground: '#FFF3E0',
        overrideBackgroundDisabled: '#F8BC000F',
        overrideBorder: '#F8BC00',
        overrideBorderHover: '#F8BC00B3',
    },
    fileStatus: {
        new: lightGreen[600],
        bulkUploadReview: red[600],
        inProcess: green[600],
        reviewResearch: yellow[600],
        pendingInternalResponse: amber[600],
        pendingAgentResponse: purple[600],
        pendingEscrowResponse: pink[600],
        reconciled: indigo[600],
        closed: grey[600],
    },
});
